import { gql } from 'apollo-angular';

const EXTEND_RFP_RESPONSE_DUE_DATE = gql`
  mutation extendRfpResponseDueDate($rfpId: Long!, $responseDueDate: Date!) {
    extendRfpResponseDueDate(
      extendRfpResponseDueDateRequest: {
        id: $rfpId
        extendedResponseDueDate: $responseDueDate
      }
    ) {
      id
      status
      offersDueDate
    }
  }
`;

export default EXTEND_RFP_RESPONSE_DUE_DATE;